// extracted by mini-css-extract-plugin
module.exports = {"column1":"BulletinTableRow_column1__2p62o","column3":"BulletinTableRow_column3__3ARMs","stat":"BulletinTableRow_stat__iwue6","statIcon":"BulletinTableRow_statIcon__31bOu"};